import { render, staticRenderFns } from "./electricalparameters.vue?vue&type=template&id=7cda68b2&"
import script from "./electricalparameters.vue?vue&type=script&lang=ts&"
export * from "./electricalparameters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "electricalparameters.vue"
export default component.exports